import { usePrevious } from '@fl/cmsch-fe-library';
import React, { FC, memo, PropsWithChildren, useLayoutEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { opt } from 'ts-opt';
import { Config } from 'app/config';
import { simpleUserSelector, userAction } from 'app/user';
import { MenuLayout } from '../main-menu/menu-layout';
const MenuAppWrapperBase: FC<PropsWithChildren> = props => {
  const {
    children
  } = props;
  const dispatch = useDispatch();
  const isE2E = Config.e2e;
  const [isSiderActive, setIsSiderActive] = useState<boolean>(false);
  const [isSideMenuCollapsed, setIsSideMenuCollapsed] = useState<boolean>(true);
  const {
    pathname
  } = useLocation();
  const reduxPathname = useSelector(simpleUserSelector.currentPathname);
  const prevPathname = usePrevious(pathname);
  useLayoutEffect(() => {
    if (prevPathname !== pathname) {
      dispatch(userAction.setPreviousAndCurrentPathname(opt(prevPathname), opt(pathname)));
    }
  }, [dispatch, pathname, prevPathname]);
  const routePathnameIsSynchronized = reduxPathname === pathname;
  return <MenuLayout isE2E={isE2E} isSideMenuCollapsed={isSideMenuCollapsed} isSiderActive={isSiderActive} setIsSiderActive={setIsSiderActive} setIsSideMenuCollapsed={setIsSideMenuCollapsed} data-sentry-element="MenuLayout" data-sentry-component="MenuAppWrapperBase" data-sentry-source-file="index.tsx">
            {routePathnameIsSynchronized ? children : null}
        </MenuLayout>;
};

/**
 * Keeps menu state and pathname tracking aligned while rendering the shared app shell layout.
 *
 * @param props Routed application content.
 * @returns Routed content wrapped in the menu shell.
 *
 * @example
 * <MenuAppWrapper>
 *     <AppRoutes />
 * </MenuAppWrapper>
 */
export const MenuAppWrapper = memo(MenuAppWrapperBase);